module.exports = __webpack_public_path__ + "assets/hugo.a8a06bb0.svg";